import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import BreadCrums from "../components/BreadCrums";
import TableComponent from "../components/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans, getCompanies } from "../redux/actions/dashBoardActions";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import UpGradePlan from "../modals/UpGradePlan";
import { Api } from "../config/apiEndPoints";
import { callApi } from "../config/apiCall";
import InvoicePreview from "../modals/InvoicePreview";
import { getFirstErrorMessage, hasValidationError, validatedFields, validationError } from "../helpers/frontend";
import { toast } from "react-toastify";
import { getSuperAdminList } from "../redux/actions/otherActions";
import NoData from "../components/NoData";

const AdminsList = () => {
  const dispatch = useDispatch()
  const [modalData, setModalData] = useState({ isOpen: false, data: "" })
  const isLoading = useSelector((state) => state.commenData.loading)
  const superadminData = useSelector((state) => state.data?.superAdminList)
  const [searchText, setSearchText] = useState("")
  const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({ name: "", email: "", password: "" })
  // const [filters, setFilters] = useState({
  //   limit: 10,
  //   page: 1,
  //   deliver: "",
  //   status: "",
  //   sort: "",
  //   currentPage: 1,
  // })
  const [isloading, setLoading] = useState(false)

  useEffect(() => {
    dispatch(getSuperAdminList({}))
  }, [])

  useEffect(() => {
    // //console.log(modalData , "<<<<sdf");
    if (modalData.data) {
      setFormData(modalData?.data)
    }
  }, [modalData])

  const tableHeader = [
    "Name",
    "Email",
    // "Phone",
    "Password",
  ];

  const dataKeys = [
    "name",          // Company Name
    "email",
    // "plan_name",
    "password",
  ];

  // //console.log("superadminData" ,superadminData);

  const onTextChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // //console.log("formData", formData);
  }

  const onClose = () => {
    setModalData((prev) => ({
      ...prev,
      type: "",
      isOpen: false,
    }))
  }
  const handleActions = (data, type) => {
    setModalData((prev) => ({
      ...prev,
      data: data,
      type: type,
      isOpen: true,
      onConfirm: "",
      onClose: onClose
    }))
  }



  const requiredFields = ["name", "email", "password"]

  const handleSubmit = async (e) => {
    e.preventDefault();
    // //console.log("formData", errors ,formData);
    if (!validatedFields(formData, requiredFields, setErrors)) return;
    try {
      setLoading(true)
      let data = new FormData()
      Object.entries(formData)?.map(([key, value]) => {
        data.append(key, value)
      })
      const response = await callApi(Api.CREATEADMIN + `${modalData?.type == "edit" ? "/" + modalData.data.id : ""}`, "POST", data, details?.token)
      //console.log("response admin added", response);
      toast.success(response.message || response.data?.message || "Form submitted successfully!");
      setLoading(false)
      onClose()

    } catch (error) {
      // console.error("Error submitting form", error);
      if (error.response.data.errors) {
        toast.error(error.response.data.errors[0] || getFirstErrorMessage(error.response.data.errors))
      } else {
        toast.error(error.response.data.message || error.message || "server error");
      }
      setLoading(false)
    }
  };

  // //console.log("pageStats" ,pageStats);



  return (
    <React.Fragment>
      <MainLayout>
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <BreadCrums
                title={"Super Admin"}
                data={[
                  { path: "/superadmin/", title: "Superadmin" },

                  { path: "#", title: "Admins List" },
                ]}
              />
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">

                <div className="mb-2">
                  <a
                    to="#"
                    onClick={() => {
                      setModalData((prev) => ({
                        ...prev,
                        isOpen: true,
                        type: "add",
                        onClose: onClose
                      }))
                    }}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    Add New
                    <i className="ti ti-circle-plus ml-1" />
                  </a>
                </div>
                <div className="ms-2 head-icons"></div>
              </div>
            </div>

            {
              isLoading ?
                <Loader /> :
                <div className="card">
                  {
                    superadminData?.data?.length == 0 ? <NoData /> : <>
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Super Admin List </h5>

                      </div>
                      <div className="row align-items-center px-3">
                        <div className="col-sm-12 col-md-6">
                          <div className="dataTables_length" >
                            {/* <label>Entries
                          <select value={filters?.limit} onChange={(e) => {
                            changeFilter(e.target.value, "limit")
                          }} className="form-select form-select-sm">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </label> */}
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                          <div className="dataTables_filter m-0 text-end py-3">
                            <label>
                              <input type="search"
                                className="form-control form-control-sm"
                                placeholder="Search"
                                value={searchText}
                                onChange={(e) => {
                                  setSearchText(e.target.value)
                                }}
                              />
                            </label></div>
                        </div>
                      </div>
                      <div className="card-body sv-card-body p-3">
                        <div className="custom-datatable-filter table-responsive">
                          <TableComponent
                            tableHeader={tableHeader}
                            dataSource={superadminData?.data?.filter((item) => {
                              if (searchText) {
                                return item.name.toLowerCase().includes(searchText.toLowerCase()) ||
                                  item.email.toLowerCase().includes(searchText.toLowerCase())
                              }
                              return item
                            }) || []}
                            // historyLink={"/plans-history"}//here will be the history page link
                            dataKeys={dataKeys || []}
                            onEdit={handleActions}
                            onView={handleActions}
                          // handleDelete={handleActions}
                          />
                        </div>
                      </div>
                    </>
                  }
                </div>
            }
            {/* <Pagination pagination={companiesData?.pagination} onPageChange={handlePageChange} /> */}
          </div>

        </div>
      </MainLayout>

      <div
        style={modalData?.isOpen ? { display: "block", background: "rgba(0,0,0,0.24)" } : {}}
        className={`modal fade ${modalData?.isOpen ? "show" : ""} `}
        id="edit_company" >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content shadow">
            <div className="modal-header">
              <h4 className="modal-title">
                {
                  modalData.type == "view" ? "Admin Details" : modalData.type == "edit" ? "Update Admin Details" : "Create Super Admin"
                }

              </h4>
              <button type="button"
                className="btn-close custom-btn-close"
                onClick={() => {
                  onClose()
                }}>
                <i className="ti ti-x"></i>
              </button>
            </div>
            <form onSubmit={(e) => {
              if (!isloading) {
                handleSubmit(e)
              }
            }}>
              <div className="modal-body pb-0 d-flex flex-column gap- ">
                <div className="row" >
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control"
                        value={formData.name}
                        name='name'
                        disabled={modalData.type == "view"}
                        onChange={onTextChange} />
                      {hasValidationError(errors, "name") && (
                        <small className="text-danger pt-1">{validationError(errors, "name")}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input type="email" className="form-control"
                        value={formData.email}
                        name='email'
                        disabled={modalData.type == "view"}
                        onChange={onTextChange} />
                      {hasValidationError(errors, "email") && (
                        <small className="text-danger pt-1">{validationError(errors, "email")}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <input type="password" className="form-control"
                        value={formData.password}
                        name='password'
                        disabled={modalData.type == "view"}
                        onChange={onTextChange} />

                      {hasValidationError(errors, "password") && (
                        <small className="text-danger pt-1">{validationError(errors, "password")}</small>
                      )}
                    </div>
                  </div>


                </div>
              </div>
              {
                modalData.type == "view" ? "" :
                  <div className="modal-footer text-start">
                    <button type="submit" className="btn btn-primary">{isloading ? "Loading ..." : "Submit"}</button>
                  </div>
              }
            </form>

          </div>
        </div>
      </div>



    </React.Fragment>
  );
};

export default AdminsList;
